import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "../../../theme/customTheme";

export const useStyles = makeStyles({
  skeleton: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: designTokens.spacing[6],
    padding: "10px 20px",
    boxSizing: "border-box",
  },

  messageBlock: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
  },

  messageBlockRight: {
    alignItems: "flex-end",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },

  headerLines: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },

  headerName: {
    width: "100px",
  },

  headerRole: {
    width: "60px",
  },

  contentLines: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    paddingLeft: "44px",
  },

  contentLineFull: {
    width: "100%",
  },

  contentLineMedium: {
    width: "85%",
  },

  contentLineShort: {
    width: "70%",
  },

  tagRow: {
    display: "flex",
    gap: designTokens.spacing[2],
    paddingLeft: "44px",
  },

  tagSmall: {
    width: "60px",
  },

  tagMedium: {
    width: "80px",
  },
});
